// --- 🚀 新增：开发环境 Fetch 自动重试逻辑 ---
export const devRetryFetch = () => {
  if (import.meta.env.VITE_DEV_RETRY_FETCH === 'true') {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      let retries = 4; // 最大重试次数
      let delay = 800; // 初始重试延迟 (ms)

      while (retries > 0) {
        try {
          const response = await originalFetch(...args);

          // 如果遇到 Vinxi 返回的 503，且还有重试机会
          if (response.status === 503 && retries > 1) {
            console.warn(`[Dev Proxy] 检测到 503，正在重试... 剩余次数: ${retries - 1}`);
            retries--;
            await new Promise((resolve) => setTimeout(resolve, delay));
            delay *= 1.5;
            continue;
          }
          return response;
        } catch (error) {
          // 处理网络中断 (VPN 断连等情况)
          if (retries > 1) {
            console.error(`[Dev Proxy] 网络连接错误，正在尝试重连...`, error);
            retries--;
            await new Promise((resolve) => setTimeout(resolve, delay));
            continue;
          }
          throw error;
        }
      }
      return originalFetch(...args);
    };
  }
};
